import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '@veda/dashboard-ui';
import {
  MdBarChart,
  MdTimeline,
  MdPerson,
  MdCampaign,
  MdPieChart,
} from 'react-icons/md';

const REPORT_CARDS = [
  {
    path: 'ppp/report/avanzamento',
    icon: <MdTimeline className="w-7 h-7" />,
    titleKey: 'ppp_report_avanzamento_titolo',
    descKey: 'ppp_report_avanzamento_desc',
    color: 'blue',
  },
  {
    path: 'ppp/report/termini',
    icon: <MdBarChart className="w-7 h-7" />,
    titleKey: 'ppp_report_termini_titolo',
    descKey: 'ppp_report_termini_desc',
    color: 'orange',
  },
  {
    path: 'ppp/report/performance-rup',
    icon: <MdPerson className="w-7 h-7" />,
    titleKey: 'ppp_report_performance_rup_titolo',
    descKey: 'ppp_report_performance_rup_desc',
    color: 'red',
  },
  {
    path: 'ppp/report/pubblicazioni',
    icon: <MdCampaign className="w-7 h-7" />,
    titleKey: 'ppp_report_pubblicazioni_titolo',
    descKey: 'ppp_report_pubblicazioni_desc',
    color: 'purple',
  },
  {
    path: 'ppp/report/statistiche',
    icon: <MdPieChart className="w-7 h-7" />,
    titleKey: 'ppp_report_statistiche_titolo',
    descKey: 'ppp_report_statistiche_desc',
    color: 'green',
  },
];

const COLOR_MAP = {
  blue:   { bg: 'bg-blue-50 dark:bg-blue-900/20',   icon: 'text-blue-600',   border: 'hover:border-blue-300' },
  orange: { bg: 'bg-orange-50 dark:bg-orange-900/20', icon: 'text-orange-600', border: 'hover:border-orange-300' },
  red:    { bg: 'bg-red-50 dark:bg-red-900/20',     icon: 'text-red-600',    border: 'hover:border-red-300' },
  purple: { bg: 'bg-purple-50 dark:bg-purple-900/20', icon: 'text-purple-600', border: 'hover:border-purple-300' },
  green:  { bg: 'bg-green-50 dark:bg-green-900/20', icon: 'text-green-600',  border: 'hover:border-green-300' },
};

export default function ReportisticaPage() {
  const { _locate } = useStateContext();
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {_locate('ppp_reportistica_titolo')}
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          {_locate('ppp_reportistica_sottotitolo')}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {REPORT_CARDS.map((card) => {
          const colors = COLOR_MAP[card.color];
          return (
            <button
              key={card.path}
              onClick={() => navigate(`/${card.path}`)}
              className={`text-left bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm transition-all ${colors.border} hover:shadow-md cursor-pointer`}
            >
              <div className={`inline-flex p-3 rounded-lg ${colors.bg} ${colors.icon} mb-4`}>
                {card.icon}
              </div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-1">
                {_locate(card.titleKey)}
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                {_locate(card.descKey)}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
